module.exports = __webpack_public_path__ + "c121d0669a3d5edbd2e12a57344eea70.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold.svg
// module id = 1546
// module chunks = 0